//#region REACT
/* eslint-disable react/jsx-pascal-case */
import { Component } from "react";
import ReactModal from "react-modal";
import axios from "axios";
//#endregion

//#region COMPONENTS
import { NanoFlex } from "../../Elements/NanoFlex";
import Type from "../../Elements/Typography";
import Table from "../../Elements/Map/Table";
import SingleSelectionDropdown from "../../Elements/SingleSelectionDropdown";
import Metrics from "../Modal/Metrics";
import Graphs from "../Modal/Graphs";
//#endregion

//#region IMAGES
import { ReactComponent as Close } from "../../../images/Icons/close.svg";
//#endregion

//#region UTILS
import { endpoints } from "../../../core/constants";
import { Metrics as MetricsEnum } from "../../../core/constants";
import { formatDate } from "../../../core/utils";
import { withTranslation } from "react-i18next";
//#endregion

class MapModal extends Component {
  constructor(props) {
    super(props);

    var dateLessSevenDays = new Date();
    dateLessSevenDays.setDate(dateLessSevenDays.getDate() - 7);

    this.state = {
      selectedMetric: 1,
      selectedDate: dateLessSevenDays,
      zoomDateStart: null,
      zoomDateEnd: null,
      selectedDays: 7,
      graphData: [],
      loadingGraph: true,
    };
    this.handleCloseModal = this.handleCloseModal.bind(this);
  }

  //#region FUNCTIONS

  handleCloseModal() {
    this.props.onShowModal(false);
  }

  url(fullMetrics, gas, startDate, endDate) {
    const curentDate = new Date();

    return (
      (fullMetrics ? endpoints.metrics : endpoints.meanMetrics) +
      "?ID=BB35977C8C4BF0468808EA6D50CA70E8" + //BB35977C8C4BF0468808EA6D50CA70E8
      //this.props.id +
      "&startDate=" +
      (startDate
        ? startDate
        : Math.trunc(
            (this.state.zoomDateStart?.getTime() ??
              this.state.selectedDate.getTime()) / 1000
          )) +
      "&endDate=" +
      (endDate
        ? endDate
        : Math.trunc(
            (this.state.zoomDateEnd?.getTime() ?? curentDate.getTime()) / 1000
          )) +
      "&Metrics=" +
      (this.state.selectedMetric === 3
        ? gas
          ? "Gas"
          : "CO2"
        : this.state.selectedMetric === 4
        ? "Movement"
        : Object.keys(MetricsEnum)[this.state.selectedMetric])
    );
  }

  getGraphData(fullMetrics) {
    const headers = {
      cache: "default",
      mode: "cors",
      credentials: "include",
      "content-type": "application/json",
    };

    this.setState({ loadingGraph: true });

    console.log(this.url(fullMetrics, false));

    // GET GRAPH DATA BASE
    axios
      .get(this.url(fullMetrics, false), {
        headers: headers,
        withCredentials: true,
      })
      .then((response) => {
        var result;

        //IN CASE OF BEING GAS OR CO2 GENERATE COMBINED DATA RESULT
        if (this.state.selectedMetric === 3) {
          console.log(this.url(fullMetrics, true));

          axios
            .get(this.url(fullMetrics, true), {
              headers: headers,
              withCredentials: true,
            })
            .then((gas) => {
              //CO2 DATA
              if (response?.data?.message) {
                result = [];
              } else {
                result = response.data[Object.keys(response.data)[0]][
                  Object.keys(response.data[Object.keys(response.data)[0]])[0]
                ]?.map((m) => ({
                  _value: m.Value,
                  name: new Date(m.Timestamp * 1000).toLocaleString(),
                }));
                console.log("co2: ", result);
              }
              //GAS DATA
              if (gas?.data?.message) {
                gas = [];
              } else {
                gas = gas.data[Object.keys(gas.data)[0]][
                  Object.keys(gas.data[Object.keys(gas.data)[0]])[0]
                ]?.map((m) => ({
                  _value: m.Value,
                  name: new Date(m.Timestamp * 1000).toLocaleString(),
                }));
                console.log("gas: ", gas);
              }
              // MERGE TWO DATAS
              if (gas?.length > 0) {
                result = result.map((e, i) => {
                  return {
                    name: e.name,
                    _value: gas[i]._value,
                    _value_co2: e._value,
                  };
                });
              }
              // SET STATE
              this.setState({
                graphData: result,
                loadingGraph: false,
              });
            });
        } else {
          if (response?.data?.message) {
            result = [];
          } else {
            result = response.data[Object.keys(response.data)[0]][
              Object.keys(response.data[Object.keys(response.data)[0]])[0]
            ]?.map((m) => ({
              _value: m.Value,
              name: new Date(m.Timestamp * 1000).toLocaleString(), //this.state.zoomDateStart !== null && this.state.zoomDateEnd !== null ? new Date(m.Timestamp * 1000).getHours() :
            }));
          }
        }

        //GET HOMOLGUE PERIOD ONLY FOR TEMPERATURE OR HUMIDITY
        if (
          this.state.selectedMetric === 1 ||
          this.state.selectedMetric === 2
        ) {
          //SET VARIABLES ACCORDING ZOOM PROPERTY
          //IF THERE IS ZOOM THEN START AND END SHULD BE this.state.selectedDate -1 DAY
          let startDate = this.state.zoomDateStart ?? this.state.selectedDate;
          let endDate = this.state.zoomDateEnd ?? this.state.selectedDate;
          startDate = startDate.setDate(
            startDate.getDate() -
              (this.state.zoomDateStart ? 1 : this.state.selectedDays)
          );
          endDate = endDate.setDate(
            endDate.getDate() +
              (this.state.zoomDateStart ? -1 : this.state.selectedDays)
          );

          console.log(
            this.url(
              fullMetrics,
              false,
              Math.trunc(new Date(startDate).getTime() / 1000),
              Math.trunc(new Date(endDate).getTime() / 1000)
            )
          );

          axios
            .get(
              this.url(
                fullMetrics,
                false,
                Math.trunc(new Date(startDate).getTime() / 1000),
                Math.trunc(new Date(endDate).getTime() / 1000)
              ),
              { headers: headers, withCredentials: true }
            )
            .then((response) => {
              if (response?.data?.message) {
                result = [];
              } else {
                //DATA
                var homologue = response.data[Object.keys(response.data)[0]][
                  Object.keys(response.data[Object.keys(response.data)[0]])[0]
                ]?.map((m) => ({
                  _value_homologue: m.Value,
                  _name_homologue: new Date(m.Timestamp * 1000).toLocaleString()
                }));

                console.log(homologue);
                // MERGE DATA WITH HOMOLOGUE
                if (homologue?.length > 0) {
                  result = result.map((e, i) => {
                    return {
                      name: e.name,
                      _value: e._value,
                      _value_homologue: homologue[i]._value_homologue,
                    };
                  });
                }
              }

              console.log(result);

              this.setState({
                graphData: result,
                loadingGraph: false,
              });
            });
        } else if (this.state.selectedMetric !== 3) {
          this.setState({
            graphData: result,
            loadingGraph: false,
          });
        }
      });
  }

  //#endregion

  //#region COMPONENT LOAD
  componentDidMount() {
    this.getGraphData();
  }

  componentDidUpdate(prevProps, prevState) {
    //COMPONENT UPDATE BY METRIC OR DATE
    if (
      prevState.selectedMetric !== this.state.selectedMetric ||
      prevState.selectedDate !== this.state.selectedDate
    ) {
      this.getGraphData(false);
    }

    //COMPONENT UPDATE BY ZOOM
    if (
      (prevState.zoomDateStart !== this.state.zoomDateStart ||
        prevState.zoomDateEnd !== this.state.zoomDateEnd) &&
      prevState.selectedMetric === this.state.selectedMetric &&
      prevState.selectedDate === this.state.selectedDate
    ) {
      this.getGraphData(true);
    }
  }
  //#endregion

  render() {
    //FILTER TABLE INCIDENTS BASED ON METRIC SELECTED
    var groupedIncidents = this.props.incidents
      .filter((f) => {
        const existentIndicators =
          Object.values(MetricsEnum)[this.state.selectedMetric] ?? "";

        return existentIndicators
          .split(",")
          .some((v) => f.category?.includes(v));
      })
      .sort(function (a, b) {
        return new Date(b.open_date) - new Date(a.open_date);
      });

    return (
      <ReactModal
        isOpen={this.props.isOpen}
        className="modal"
        ariaHideApp={false}
        overlayClassName="overlay"
      >
        {/* HEADER */}
        <NanoFlex height="7vh">
          <NanoFlex justifyContent="flex-start">
            <Type.h4 className="modalTitle">
              {this.props.name ?? ""} {this.props.t("map.house")}
            </Type.h4>
            <Type.p>
              <b>{this.props.t("severity")}:</b>
            </Type.p>
            <NanoFlex width="auto">
              <NanoFlex
                color={this.props.color ?? ""}
                radius="10px"
                padding="2px"
                margin="0 10px 0 10px"
                width="5px"
                height="5px"
              ></NanoFlex>
              <Type.p className="severityName">
                {this.props.severityName ?? ""}
              </Type.p>
            </NanoFlex>
          </NanoFlex>
          <NanoFlex justifyContent="flex-end" alignItems="flex-start">
            <button className="closeModal" onClick={this.handleCloseModal}>
              <Close></Close>
            </button>
          </NanoFlex>
        </NanoFlex>
        {/* METRICS */}
        <Metrics
          selectedMetric={this.state.selectedMetric}
          onMetricChange={(e) =>
            this.setState({
              selectedMetric: e,
              zoomDateStart: null,
              zoomDateEnd: null,
              graphData: [],
            })
          }
        ></Metrics>
        {/* FILTER */}
        <NanoFlex height="10vh" flexDirection="column" alignItems="flex-start">
          <Type.p className="titleForm">
            <b>{this.props.t("dashboard.timeframe")}</b>
          </Type.p>
          <SingleSelectionDropdown
            placeholder="Placeholder"
            searchable={false}
            selected={1}
            options={[
              { id: 1, name: this.props.t("last7days") },
              { id: 2, name: this.props.t("last15days") },
              { id: 3, name: this.props.t("last30days") },
            ]}
            onChangeSelection={(e) => {
              var dynamicDate = new Date();
              e = e ?? this.state.selectedDays;
              dynamicDate.setDate(
                e.id === 1
                  ? dynamicDate.getDate() - 7
                  : e.id === 2
                  ? dynamicDate.getDate() - 15
                  : dynamicDate.getDate() - 30
              );
              this.setState({
                selectedDate: dynamicDate,
                selectedDays: e.id === 1 ? 7 : e.id === 2 ? 15 : 30,
                zoomDateStart: null,
                zoomDateEnd: null,
                graphData: [],
              });
              this.props.onDateFilterChange(dynamicDate);
            }}
          />
        </NanoFlex>
        {/* CONTENT */}
        <NanoFlex height="40vh">
          {/* GRAPH */}
          <Graphs
            data={this.state.graphData}
            isLoading={this.state.loadingGraph}
            days={this.state.selectedDays}
            metric={this.state.selectedMetric}
            onZoomGraph={(e) => {
              const startZoom = e.setHours(e.getHours() - 2);
              const endZoom = e.setHours(e.getHours() + 4);
              this.setState({
                zoomDateStart: new Date(startZoom),
                zoomDateEnd: new Date(endZoom),
              });
            }}
          ></Graphs>
          {/* TABLE */}
          <NanoFlex>
            <Table
              data={groupedIncidents?.map((m) => {
                return [
                  formatDate(new Date(m.open_date)),
                  m.resolution_code === "400104" ||
                  m.resolution_code === "400105"
                    ? "Yes"
                    : "No",
                  m.status,
                  m.priority === "3 - Medium" ||
                  m.priority === "4 - Medium Low" ||
                  m.priority === "5 - Low"
                    ? 3
                    : m.priority === "2 - Medium High"
                    ? 2
                    : 1,
                ];
              })}
              isLoading={this.props.loadingTable}
            ></Table>
          </NanoFlex>
        </NanoFlex>
      </ReactModal>
    );
  }
}

export default withTranslation()(MapModal);
